<template>
	<div class="formTabWrapper">
		<div class="formTabTableWrap">
			<div class="formTabTableWrap_top">
				<div class="formTabTableWrap_top-title">Equipment</div>
				<div class="formTabTableWrap_top-add">

					<v-btn
							@click="onRefreshFilters" type="button"
							depressed
							class="mainBtn mainBtn-text iconHoverRotate"
					>
						<span class="btnIco"><svg-sprite icon-id="refresh" width="20" height="20"></svg-sprite></span>
						<span class="btnText">Refresh filters</span>
					</v-btn>
					<v-btn
							:disabled="getPermissionAction" @click="onEquipmentPopupHandler(true)" type="button"
							depressed
							class="mainBtn mainBtn-text"
					>
						<span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
						<span class="btnText">Add new</span>
					</v-btn>

				</div>
			</div>
			<div class="formTabTableWrap_body">
				<equipment
						v-if="equipmentFilterTrailer"
						:listItems="equipmentListTrailer"
						:filter="equipmentFilterTrailer"
						:isRefresh="isRefresh"
						:trailerId="trailerId"
						:getPermissionAction="getPermissionAction"
						@updateEdit="onEdit"
						@updateRemoveItem="setRemoveItem"
				></equipment>
			</div>
		</div>

		<equipment-popup
				v-if="isEquipmentPopup"
				:equipments="getEquipments"
				:drivers="drivers"
				:editItem="editItem"
				@updateEquipmentList="onUpdateEquipmentList"
				@updateSearchText="onSearchText"
				@updateClose="onEquipmentPopupHandler(false)"
		></equipment-popup>

		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="isRemove = false"
		></remove-block>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import Equipment from "@/components/Maintenance/Trailers/TrailersForm/Equipment/Equipment";
// async components
const EquipmentPopup =
		() => import("@/components/Maintenance/Trailers/TrailersForm/EquipmentPopup/EquipmentPopup");
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
// helpers
import getUniqId from "@/helper/getUniqId";

export default {
	name: "ThirdTab",
	components: {
		Equipment,
		EquipmentPopup,
		RemoveBlock
	},
	props: {
		trailerId: Number,
		equipments: Array,
		drivers: Array,
		getPermissionAction: Boolean,
	},
	data: () => ({
		isEquipmentPopup: false,
		editItem: null,
		isRefresh: null,
		removeItem: null,
		isRemove: false
	}),
	computed: {
		...mapGetters([ 'equipmentListTrailer', 'equipmentFilterTrailer' ]),
		getEquipments: {
			get() {
				return this.equipments;
			},
			set(values) {
				this.$emit('updateEquipmentsSelectList', values);
			}
		}
	},
	methods: {
		...mapActions([
			'onEquipmentListTrailer',
			'onEquipmentCreateTrailer',
			'onEquipmentSelectItemTrailer',
			'onEquipmentEditTrailer',
			'onEquipmentRemoveTrailer'
		]),
		onRefreshFilters() {
			this.isRefresh = getUniqId();
		},
		onEquipmentPopupHandler(value) {
			this.isEquipmentPopup = value;
			if (!value) this.editItem = null;
		},
		async onUpdateEquipmentList(values) {
			values.trailerId = this.trailerId;
			await this.onEquipmentCreateTrailer(values);
		},
		async onSearchText(name) {
			this.getEquipments = await this.onEquipmentSelectItemTrailer(name);
		},
		async onEdit(id) {
			this.editItem = await this.onEquipmentEditTrailer(id);
			this.isEquipmentPopup = true;
		},
		async setRemoveItem(id) {
			this.removeItem = { trailerId: this.trailerId, id };
			this.isRemove = true;
		},
		async onRemoveItem() {
			await this.onEquipmentRemoveTrailer(this.removeItem);
			this.isRemove = false;
		}
	},
	mounted() {
		this.onEquipmentListTrailer(this.trailerId);
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/style/components/formTab/formTabTableWrap";
</style>
